const state = () => ({
  isValid: false,
  companyEmployees: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  companyEmployees(state) {
    return state.companyEmployees;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateCompanyEmployees(state, payload) {
    state.companyEmployees = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

const actions = {
  updateCompanyEmployees({ commit }, payload) {
    commit('updateCompanyEmployees', payload);
  }
};

export const companyEmployees = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
